export default __webpack_public_path__ + "static/media/hostaway_step1.a88095e9.jpg";